export default {
      id: "key-solid-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "img/icons.6f915410.svg#key-solid",
      toString: function () {
        return this.url;
      }
    }